// popupの設定
document.querySelectorAll('a.popup').forEach(function(link) {
  link.addEventListener('click', {
    handleEvent: function(e) {
      e.preventDefault();
      const width = e.target.dataset.width || 810;
      const height = e.target.dataset.height || 880;
      window.open(e.target.href, 'popup', `width=${width},height=${height},scrollbars=1,resizable=1`).focus();
    },
  });
});
